export default __webpack_public_path__ + "static/media/person.e47f33de.png";